import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";
import { BannerImage } from "@/components/banner/BannerImage";
import type { CoverFraming } from "@/lib/bannerFraming";

interface ArtistBannerProps {
  imageUrl: string | null | undefined;
  framing: CoverFraming | null;
  artistName: string;
}

export function ArtistBanner({ imageUrl, framing, artistName }: ArtistBannerProps) {
  const [loaded, setLoaded] = useState(false);

  return (
    <section className="relative h-56 sm:h-72 md:h-80 overflow-hidden bg-[var(--color-bg-card)]">
      {imageUrl ? (
        <BannerImage
          url={imageUrl}
          framing={framing}
          alt={`${artistName}'s cover`}
          priority
          className={cn("transition-opacity duration-500", loaded ? "opacity-100" : "opacity-0")}
          // Cached images can finish before React attaches onLoad.
          ref={(el) => {
            if (el?.complete && el.naturalWidth > 0) setLoaded(true);
          }}
          onLoad={() => setLoaded(true)}
        />
      ) : (
        <div className="h-full w-full bg-gradient-to-br from-[var(--color-primary)]/30 to-[var(--color-primary)]/10" />
      )}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[var(--color-bg)] to-transparent" />

      <Link
        to="/"
        className="absolute top-4 left-4 sm:top-6 sm:left-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-[var(--color-bg)]/80 backdrop-blur-sm border border-[var(--color-border)] text-[var(--color-text)] hover:bg-[var(--color-bg)] transition-colors text-sm"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </Link>
    </section>
  );
}
